<template>
  <div class="product-price">
    <table>
      <tr>
        <td>{{ $t('customerPrice') }} ({{ $t('excludingVat') }})</td>
        <td v-if="value.type === 'area'" class="product-price__area">x {{ area }} m² =</td>
        <td class="product-price__value-raw" :style="{ opacity: net !== netRounded ? 1 : 0 }">{{ net | Currency }}</td>
        <td class="product-price__value">{{ netRounded | Currency }}</td>
      </tr>
      <tr>
        <td>{{ $t('customerPrice') }} ({{ $t('includingVat') }})</td>
        <td v-if="value.type === 'area'" class="product-price__area">x {{ area }} m² =</td>
        <td class="product-price__value-raw" :style="{ opacity: gross !== grossRounded ? 1 : 0 }">
          {{ gross | Currency }}
        </td>
        <td class="product-price__value">{{ grossRounded | Currency }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { getNet, getGross } from './utils'
import { Currency } from '@/filters'
export default {
  props: {
    value: Object,
    area: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    net() {
      return getNet(this.value, { area: this.area, round: false })
    },
    gross() {
      return getGross(this.value, { area: this.area, round: false })
    },
    netRounded() {
      return getNet(this.value, { area: this.area })
    },
    grossRounded() {
      return getGross(this.value, { area: this.area })
    },
  },
  filters: {
    Currency,
  },
}
</script>

<style lang="scss">
.product-price {
  border-radius: var(--border-radius);
  background-color: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.1);
  padding: 1rem;
  margin-top: 1rem;

  table {
    border-collapse: collapse;
    width: 100%;
  }

  &__value {
    font-weight: bold;
    text-align: right;

    &-raw {
      text-decoration: line-through;
      margin-right: 10px;
      text-align: right;
      opacity: 0.4;
    }
  }

  &__area {
    opacity: 0.5;
    font-style: italic;
  }

  &__item {
    display: flex;
    justify-content: space-between;

    & + .product-price__item {
      margin-top: 0.25rem;
    }
  }

  label {
    font-weight: normal;
  }
}
</style>
